import React from 'react';
import { Route, Redirect, Switch, withRouter } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import session from '../session';
import Login from './Login';
import Internal from './Internal';

const AuthCheck = inject('session')(
    withRouter(
        observer(
            ({ location }) =>
                session.loggedIn ? (
                    <Internal />
                ) : (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: { next: location.pathname }
                        }}
                    />
                )
        )
    )
);

class Pages extends React.Component {
    render() {
        return (
            <Switch>
                <Route exact={true} path="/login" component={Login} />
                <AuthCheck />
            </Switch>
        );
    }
}

export default Pages;



// WEBPACK FOOTER //
// ./src/pages/index.js